var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('div',{staticClass:"wel_content"},[_c('h1',[_vm._v("欢迎登录灵动岛系统！")])])])}]

export { render, staticRenderFns }